interface Props {
  width?: string;
  height?: string;
}

const People = ({ width = '27', height = '27' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27 27"
      fill="none"
      style={{ display: 'block' }}
    >
      <path
        d="M9 16.018c2.592 0 4.824.454 6.435 1.54C17.104 18.681 18 20.415 18 22.677a.902.902 0 0 1-1.8 0c0-1.724-.644-2.873-1.77-3.63-1.184-.796-3-1.23-5.43-1.23-2.43 0-4.248.434-5.43 1.231-1.126.758-1.77 1.907-1.77 3.631a.902.902 0 0 1-1.8 0c0-2.264.895-3.998 2.563-5.123C4.174 16.472 6.408 16.018 9 16.018zm8.955 0c2.59 0 4.824.454 6.435 1.54 1.669 1.124 2.565 2.858 2.565 5.122a.9.9 0 1 1-1.8 0c0-1.724-.644-2.873-1.771-3.63-.933-.629-2.256-1.027-3.964-1.17a8.096 8.096 0 0 0-1.566-1.86l.101-.002zM9 3.328a5.672 5.672 0 0 1 0 11.34 5.67 5.67 0 0 1 0-11.34zm8.955 0a5.67 5.67 0 1 1 0 11.34 5.631 5.631 0 0 1-2.61-.64 8.1 8.1 0 0 0 .961-1.534 3.87 3.87 0 1 0 0-6.997 8.1 8.1 0 0 0-.963-1.53 5.58 5.58 0 0 1 2.61-.639M9 5.128a3.872 3.872 0 0 0 0 7.74 3.87 3.87 0 0 0 0-7.74z"
        fill="#4B3221"
      />
    </svg>
  );
};

export default People;
